import cube, { type CubeApi } from '@cubejs-client/core';
import { AnalyticsTokenStore, isSessionExpiredError } from './analytics-token-store';
import { TokenRefreshTransport } from './cube-transport';

interface CreateCubeApiOptions {
  apiUrl: string;
  onFreshTokenRejected?: () => void;
  onSessionExpired?: (error: unknown) => void | Promise<void>;
}

function createCubeApi(options: CreateCubeApiOptions): CubeApi {
  const { apiUrl, onFreshTokenRejected, onSessionExpired } = options;
  const tokenStore = new AnalyticsTokenStore();

  const requestToken = async (refresh: boolean) => {
    try {
      return await (refresh ? tokenStore.refresh() : tokenStore.getToken());
    } catch (error) {
      if (isSessionExpiredError(error)) {
        Promise.resolve()
          .then(() => onSessionExpired?.(error))
          .catch((cause: unknown) => console.error('Could not end the expired session', cause));
      }

      throw error;
    }
  };

  const transport = new TokenRefreshTransport({
    apiUrl,
    onRefreshToken: () => requestToken(true),
    onFreshTokenRejected,
  });

  return cube(() => requestToken(false), { apiUrl, transport });
}

export { createCubeApi };
